// import { createSlice } from "@reduxjs/toolkit";

import { Store } from "./store/store";

const initialState = {
    cartItems: [],
    total: 0
  };
  
  const cartReducer = (state = initialState, action) => {
    switch (action.type) {
      case "ITEM_ADDED":
        const existingProductIndex = state.cartItems.findIndex(
            (item) => item.id === action.item.id)
        let itemPrice = action.item.discountedPrice ? action.item.discountedPrice : action.item.price;
        if (existingProductIndex >= 0) {
            const updatedCartItems = [...state.cartItems];
            updatedCartItems[existingProductIndex].quantity += 1;
            return {
              ...state,
              cartItems: updatedCartItems,
              total: state.total + itemPrice,
            };
          } else {
            return {
              ...state,
              cartItems: [
                ...state.cartItems,
                { ...action.item, quantity: 1 },
              ],
              total: state.total + itemPrice,
            };
        } 
      default:
        return state;
    }
  };

  
  export default cartReducer;
  